const PIXEL_ID = '4592591397689567'

declare global {
  interface Window {
    fbq?: ((...args: any[]) => void) & {
      callMethod?: (...args: any[]) => void
      queue?: any[]
      loaded?: boolean
      version?: string
      push?: (...args: any[]) => void
    }
    _fbq?: Window['fbq']
  }
}

let initialized = false

/**
 * Injects the official Meta Pixel snippet, initializes the pixel and fires PageView.
 * Safe to call multiple times — it only runs once.
 */
export function initPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Fires the AddToCart standard event (called right before redirecting to checkout). */
export function trackAddToCart() {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart', {
    content_name: 'Protocolo 7 Días Sin Reinfestación',
    content_ids: ['43850281549890'],
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  })
}
